// Description: Address step of the finish sign up form
// Updated: 20/08/2025
// Author: Simon Franklin

// React
import * as React from 'react';

// Material UI Components
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Input from '@mui/material/Input';
import { styled } from '@mui/material/styles';

// Components and Functions for the project
import { insertMaskForCep } from '../../../utils/utils';

const FormGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

// Render The Component
const AddressForm = ({ setCheckoutData, checkoutData }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const textFields = ['street', 'neighborhood', 'city', 'state', 'country', 'cardName'];
    const isText = textFields.includes(name);
    const textRegex = /^[A-Za-zÀ-ÿ\s]*$/;
    const numberRegex = /^\d*$/;

    if (isText && !textRegex.test(value)) return;

    setCheckoutData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const fetchAddressInfo = async (cepToSearch) => {
    const validacep = /^[0-9]{8}$/;

    if (validacep.test(cepToSearch)) {
      const res = await fetch(`https://viacep.com.br/ws/${cepToSearch}/json/`);

      if (!res.ok) throw new Error('Ocorreu algum erro, tente novamente mais tarde');

      const addressInfo = await res.json();

      setCheckoutData((prev) => ({ ...prev, state: addressInfo.estado }));
      setCheckoutData((prev) => ({ ...prev, city: addressInfo.localidade }));
      setCheckoutData((prev) => ({ ...prev, street: addressInfo.logradouro }));
      setCheckoutData((prev) => ({ ...prev, country: 'Brasil' }));
      setCheckoutData((prev) => ({ ...prev, neighborhood: addressInfo.bairro }));
    } else {
      return;
    }
  };

  return (
    <Grid container spacing={3} gap={2} justifyContent={'space-between'} sx={{ paddingLeft: { xs: "20px", sm: "0px" }}}>
      <FormGrid xs={12}>
        <FormLabel htmlFor="zipcode" required>CEP</FormLabel>
        <Input
          variant="outlined"
          id="zipcode"
          name="zipcode"
          type="text"
          placeholder="Digite seu CEP"
          autoComplete="shipping zipcode-line1"
          required
          size="small"
          value={insertMaskForCep(checkoutData.zipcode)}
          onChange={(e) => {
            const removingLetters = e.target.value.replace(/\D/g, "");
            setCheckoutData((prev) => ({ ...prev, zipcode: removingLetters }));
            fetchAddressInfo(removingLetters);
          }}
        />
      </FormGrid>
      <FormGrid xs={5.5}>
        <FormLabel htmlFor="street" required>Rua</FormLabel>
        <Input
          variant="outlined"
          id="street"
          name="street"
          type="text"
          placeholder="Digite sua Rua"
          autoComplete="street"
          required
          size="small"
          value={checkoutData.street}
          onChange={handleChange}
        />
      </FormGrid>
      <FormGrid xs={5.5}>
        <FormLabel htmlFor="streetNumber" required>Número</FormLabel>
        <Input
          variant="outlined"
          id="streetNumber"
          name="streetNumber"
          type="text"
          placeholder="Digite o número"
          autoComplete="streetNumber"
          required
          size="small"
          value={checkoutData.streetNumber}
          onChange={(e) => {
            const removingLetters = e.target.value.replace(/\D/g, "");
            setCheckoutData((prev) => ({ ...prev, streetNumber: removingLetters }));
          }}
        />
      </FormGrid>
      <FormGrid xs={5.5}>
        <FormLabel htmlFor="city" required>Cidade</FormLabel>
        <Input
          variant="outlined"
          id="city"
          name="city"
          type="text"
          placeholder="São Paulo"
          autoComplete="City"
          required
          size="small"
          value={checkoutData.city}
          onChange={handleChange}
        />
      </FormGrid>
      <FormGrid xs={5.5}>
        <FormLabel htmlFor="state" required>Estado / Província / Região</FormLabel>
        <Input
          variant="outlined"
          id="state"
          name="state"
          type="text"
          placeholder="SP"
          autoComplete="State"
          required
          size="small"
          value={checkoutData.state}
          onChange={handleChange}
        />
      </FormGrid>
      <FormGrid xs={5.5}>
        <FormLabel htmlFor="complement" required>Complemento</FormLabel>
        <Input
          variant="outlined"
          id="complement"
          name="complement"
          type="text"
          placeholder="Complemento"
          autoComplete="shipping complement-line"
          required
          size="small"
          value={checkoutData.complement}
          onChange={handleChange}
        />
      </FormGrid>
      {/* <FormGrid xs={5.5}>
        <FormLabel htmlFor="country" required>Número</FormLabel>
        <Input
          variant="outlined"
          id="number"
          name="number"
          type="text"
          placeholder="123"
          autoComplete="shipping number"
          required
          size="small"
          value={checkoutData.number}
          onChange={handleChange}
        />
      </FormGrid> */}
      <FormGrid xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              name="saveAddress"
              value="yes"
              checked={checkoutData.saveAddress}
              onChange={handleChange}
              required
            />
          }
          label="Usar este endereço para detalhes de pagamento"
        />
      </FormGrid>
    </Grid>
  );
};

export default AddressForm;
